import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../../reducers";
import { DCService } from "../../../../services/index";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./addEditWorkOrderInward.html",
})
export class addEditWorkOrderInward {
  brand: any;

  wo_no: number;
  wo_date: any;
  row: any;
  data: any;
  mode = "Add";
  dcdata: any = { dc_id: "", total_mtr: 0 };
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  desData: any = {
    totDes: 0,
  };
  barcodeList = [];
  unitList: any;
  typeList = ["Swatch", "Sample", "Work Order", "Others", "Swatch & Sample"];
  saveEvent: any;
  agentList: any;
  partyCodeList: any;

  dcList = [
    {
      barcode: "",
      design_no: "",
      color: "",
      width: "",
      qty: 0,
      mtr: 0,
      party_name: ""
    },
  ];
  woList: any = [];

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";

  isLoading = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;
  wo_id: any;
  dcList1: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    if (this.mode == "Edit" || this.mode == "View" || this.mode == "Inward") {
      const designdata = Object.assign({}, val["data"]);
      this.dcdata = designdata;

      this.getdcdesignList(this.dcdata.wo_in_id);
      this.getbarcodeList();
      // this.onChangeCode()
    }
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private dcService: DCService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) { }
  ngOnInit() {
    this.partycodelist_season();
    // this.typelist();
    if (this.mode == "Add") {
      this.dcdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAuto();
      this.getRefAutoWoI();
      this.getbarcodeList();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#section").focus();
    }, 100);
  }
  getWorkInward() {
    if (this.dcdata.wo_no) {
      let params = {
        wo_no: this.dcdata.wo_no,
      };
      let that = this;
      this.dcService.getWoI(params).then(function (res: any) {
        if (res.data.length > 0) {
          that.dcdata.wo_date = res.data[0].wo_date;
          that.wo_id = res.data[0].wo_id;
          that.dcdata.brand = res.data[0].brand;
        } else {
          that.dcdata.wo_no = '';
          swal("This WO has not been returned");
        }

      });
    }
  }

  onEnterKeyPressed(nextEl: string) {
    if (nextEl == "barcodegood") {
      $("#" + this.page_id + "barcode-0").focus();
    } else {
      $("#" + this.page_id + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    if (fld == "color") {
      let totdes = 0;
      const designlist = [];
      for (let i = 0; i < this.dcList.length; i++) {
        const design = this.dcList[i].design_no;
        if (design != "") {
          if (designlist.indexOf(design) == -1) {
            designlist.push(design);
            totdes++;
          }
        }
      }
      this.dcdata.total_design = totdes;
    }

    let nxtInd = ind,
      barcode = this.dcList[ind]["barcode"],
      design = this.dcList[ind]["design_no"],
      color = this.dcList[ind]["color"],
      width = this.dcList[ind]["width"],
      qty = this.dcList[ind]["qty"],
      mtr = this.dcList[ind]["mtr"];

    const nxtRow = $("#row-" + ind).next("tr");
    if (fld == "barcode" && nxtRow.length == 0) {
      // if(this.dcList[ind].qty==0){
      //     swal({
      //         title:"Please Enter the Valid Mtr for design "+this.dcList[ind].design_no,
      //         timer:1000,
      //         showConfirmButton:false
      //     });
      //     return false;
      // }

      const len = this.dcList.length;
      const barcode = this.dcList[len - 1]["barcode"];
      const qty = this.dcList[len - 1].qty;
      nxtInd = nxtInd + 1;
      $("#" + this.page_id + "design" + "-" + nxtInd).focus();

      if (barcode != "" && nxtInd == len) {
        this.dcList.push({
          barcode: "",
          design_no: "",
          color: "",
          width: "",
          qty: 0,
          mtr: 0,
          party_name: ""
        });

        $("#" + this.page_id + "barcode" + "-" + nxtInd).focus();
      } else if (barcode == "" && nxtInd == len) {
        const a = nxtInd - 1;
        $("#" + this.page_id + "barcode" + "-" + a).focus();
      } else {
        $("#" + this.page_id + "barcode" + "-" + nxtInd).focus();

        return false;
      }
    }

    //   nxtInd = this.designList.length - 1;
    else if (fld == "item_name") {
      const nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    } else {
      setTimeout(() => {
        $("#" + this.page_id + fld + "-" + nxtInd).focus();
      }, 200);
    }
  }

  isRowEmpty(ind) {
    const data = this.dcList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    const that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.dcList.length > 1) {
          that.dcList.splice(ind, 1);

          if (that.dcdata.type == "Work Order") {
            that.calctot();
          } else {
            let totdes = 0;
            const designlist = [];
            for (let i = 0; i < that.dcList.length; i++) {
              const design = that.dcList[i].design_no;
              if (design != "") {
                if (designlist.indexOf(design) == -1) {
                  designlist.push(design);
                  totdes++;
                }
              }
            }
            that.dcdata.total_design = totdes;
          }

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getRefAutoWoI() {
    this.dcService.getRefAutoWoI({}).then((res: any) => {
      this.dcdata.ref_no = res;
    });
  }

  getAuto() {
    this.dcService.getdcAuto({}).then((res: any) => {
      this.dcdata.dc_no = res;
    });
  }

  partycodelist_season() {
    this.dcService.partycodelist_season({}).then((res: any) => {
      this.unitList = res.data;
    });
  }
  typelist() {
    this.dcService.typelist({}).then((res: any) => {
      this.typeList = res.data;
    });
  }

  onClickCode(party_code) {
    const partyCodeList = _.filter(this.codeList, { code: party_code });
    this.dcdata.party_id = partyCodeList[0]["party_id"];
    this.dcdata.party_name = partyCodeList[0]["party_name"];
  }

  onclickunit(dept) {
    const partyCodeList = _.filter(this.unitList, { dept_name: dept });
    this.dcdata.dept_id = partyCodeList[0]["dept_id"];
  }

  getbarcodeList() {
    this.dcService.barcodelist({}).then((res: any) => {
      this.barcodeList = res.data;
      for (let i = 0; i < this.barcodeList.length; i++) {
        this.barcodeList[i].barcode = this.barcodeList[i].barcode
          .toString()
          .padStart(6, "0");
      }
    });
  }

  getdcdesignList(id) {
    const params = {
      wo_in_id: id,
    };
    this.dcService.WoIDesignList(params).then((res: any) => {
      this.dcList = res.data;
      this.dcList1 = res.data1;
      this.wo_no = this.dcList1.wo_no;

      for (let i = 0; i < this.dcList.length; i++) {
        this.dcList[i].barcode = this.dcList[i].barcode
          .toString()
          .padStart(6, "0");
      }
    });
  }
  //Barcode Reader

  onChangeCode(barcode, design, ind) {
    if (barcode.length == 6) {
      const data = _.filter(this.barcodeList, { barcode: barcode });
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.barcode == barcode) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.design_no = "";
        design.color = "";
        design.width = "";
        design.qty = "";
        design.party_name = ""

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Barcode Already Exists",
        });
      }

      if (this.dcdata.party_code == "") {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Please Enter Party Code",
        });
      } else {
        design.design_no =
          data[0]["stock_type"] == "GRN"
            ? data[0]["design_no"]
            : data[0]["fab_design"];
        design.id = data[0]["id"];
        design.color =
          data[0]["stock_type"] == "GRN" ? data[0]["shade"] : data[0]["color"];
        design.width =
          data[0]["stock_type"] == "GRN"
            ? data[0]["width"]
            : data[0]["jgrn_width"];
        design.qty = data[0]["mtrs"] > 0 ? data[0]["mtrs"] : 0;
        design.party_name = data[0]["party_code"]

        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].design_no;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
        this.dcdata.total_design = totdes;

        //get workorder number
        if (this.dcdata.type == "Work Order") {
          const params = {
            design_no: data[0]["design_no"],
          };

          this.dcService.woList(params).then((res: any) => {
            this.woList = res.data;
            this.calctot();
          });
        }
      }
    }
  }
  checkQty(qty, row, ind) {
    this.barcodeList;
    let that = this;
    this.barcodeList.forEach(function (element) {
      if (row.barcode == element.barcode) {
        if (qty > element.mtrs) {
          that.barcodeList[0].qty = 0;
          that.dcList[ind].qty = 0;
        }
      }
    });
    if (qty > row.qty) {
      this.dcList[ind].qty = 0;
    }
  }
  onSelectItem($event, design, ind) {
    const barcode = $event.item.barcode;
    if (barcode.length == 6) {
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.barcode == barcode) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.design_no = "";
        design.color = "";
        design.width = "";
        design.qty = "";
        design.party_name = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Barcode Already Exists",
        });
      }

      if (this.dcdata.party_code == "") {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Please Enter Party Code",
        });
      } else {
        design.design_no =
          $event.item.stock_type == "GRN"
            ? $event.item.design_no
            : $event.item.fab_design;
        design.id = $event.item.id;
        design.color =
          $event.item.stock_type == "GRN"
            ? $event.item.shade
            : $event.item.color;
        design.width =
          $event.item.stock_type == "GRN"
            ? $event.item.width
            : $event.item.jgrn_width;
        design.qty = $event.item.mtrs > 0 ? $event.item.mtrs : 0;
        design.party_name = $event.item.party_code

        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].design_no;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
        this.dcdata.total_design = totdes;

        //get workorder number
        if (this.dcdata.type == "Work Order") {
          const params = {
            design_no: $event.item.design_no,
          };

          this.dcService.woList(params).then((res: any) => {
            this.woList = res.data;
            this.calctot();
          });
        }
      }
    }
  }

  oncheckemptyrow() {
    const design = this.dcList;
    const desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].barcode != "") {
        desList.push(design[i]);
      }
    }
    this.dcList = desList;
    this.getRefAutoWoI();
    this.onSaveOrder();
  }
  calctot() {
    let totmtr = 0;
    for (let i = 0; i < this.dcList.length; i++) {
      const dcdata = this.dcList[i];
      totmtr += dcdata.qty;
    }

    this.dcdata.total_mtr = totmtr;
  }
  addtoFabStock(): void {
    if (this.dcdata.wo_no != '') {
      const params: any = Object.assign({}, this.dcdata);

      params["tabevent"] = undefined;
      params["dcList"] = JSON.stringify(this.dcList);
      //  params['workorder'] = this.dcdata.workorder || '';
      params["mode"] = this.mode;
      const that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to add stock?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.dcService
          .addtoFabricStock(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                const tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                const tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            const res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    } else {
      swal("Please enter WO NO");
    }
  }
  onSaveOrder(): void {
    if (this.dcdata.wo_no != '') {
      const params: any = Object.assign({}, this.dcdata);

      params["tabevent"] = undefined;
      params["brand"] = this.dcdata.brand;
      params["wo_date"] = this.dcdata.wo_date;
      if (this.mode == "Add") {
        params["wo_id"] = this.wo_id;
      } else if (this.mode == "Edit") {
        params["wo_id"] = this.dcdata.wo_id;
      }
      params["ref_no"] = this.dcdata.ref_no;
      params["wo_in_id"] = this.dcdata.wo_in_id;
      params["dcList"] = JSON.stringify(this.dcList);

      //  params['workorder'] = this.dcdata.workorder || '';
      params["mode"] = this.mode;
      params["wo_no"] = this.dcdata.wo_no;
      // params['dc_date'] = this.datePipe.transform(params['dc_date'], 'yyyy-MM-dd');
      params["wo_date"] = this.dcdata.wo_date;
      const that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this WO Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.dcService
          .addUpdateWoI(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                const tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                const tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            const res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    } else {
      swal("Please enter WO NO");
    }
  }

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/workOrderInward/addEditWorkOrderInward.ts